


import MarkedText from '@/components/common/marked-text/MarkedText.vue'
import { ProductCategory } from '@/components/products/product-categories/ProductCategory'
import {
  CategoryItem,
  GroupedCategoryItems
} from '@/components/products/products-list/products-in-category/CategoryItem'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    MarkedText
  }
})
export default class ProductsInCategory extends Vue {
  @Prop({ required: true }) categoryId!: number
  items: CategoryItem[] = []
  category: ProductCategory = null as any

  get isGrouped() {
    return this.items.length > 0 && this.items[0].group
  }

  get groups(): GroupedCategoryItems {
    return this.items.reduce((groups, current) => {
      if (!groups.hasOwnProperty(current.group)) {
        groups[current.group] = []
      }
      groups[current.group].push(current)
      return groups
    }, {} as GroupedCategoryItems)
  }

  created() {
    this.initData()
    this.fetchCategory()
  }

  @Watch('categoryId')
  onCategoryUpdated() {
    this.initData()
    this.fetchCategory()
  }

  groupEntries(group: GroupedCategoryItems) {
    return Object.entries(group).sort(([group1], [group2]) => {
      const group1Order = this.category.groupsOrder[group1]
      const group2Order = this.category.groupsOrder[group2]

      return group1Order > group2Order ? 1 : -1
    })
  }

  private async initData() {
    const { data } = await this.$axios.get<CategoryItem[]>(`/items`, {
      params: {
        'product_category.id': this.categoryId
      }
    })
    this.items = data

    if (this.items.length === 1) {
      const singleItem = this.items[0]
      const itemType = singleItem.type
      switch (itemType) {
        case 'product':
          await this.$router.push(`/produkt/${singleItem.id}/${singleItem.name}`)
          break
        case 'parts-page':
          await this.$router.push(`/czesci-akcesoria/${singleItem.id}/${singleItem.name}`)
          break
        default:
          break
      }
    }
  }

  private async fetchCategory() {
    const { data } = await this.$axios.get<ProductCategory>(`/product-categories/${this.categoryId}`)
    this.category = data
  }
}
